module.exports = __webpack_public_path__ + "media/images/left-arrow-2cd98216a5766912e74d39a570370943.png";